const jwtDecode = require('jwt-decode')
import Vue from 'vue'

function buildApiUrl(domain){
  if (!domain) return process.env.VUE_APP_API_SERVER_URL

  const temp =process.env.VUE_APP_API_SERVER_URL.split(':')
  const protocol = temp[0]
  const url = `${protocol}://${domain}`
  const port = temp.slice(-1)[0]
  if (!isNaN(port)){
    return url+':'+port
  }
  return url
}

const state = () => ({
  accessToken: null,
  refreshToken: null,
  apiDomain: null,
  user: null,
  beforePath: null
})

const getters = {
  existToken(state) {
    if (state.accessToken) return true
    return false
  },
  decodedToken(state) {
    const token = state.accessToken
    if (!token) return null
    return jwtDecode(token)
  },
  apiUrl(state){
    return buildApiUrl(state.apiDomain)
  },

  isManager(state) {
    return state.user?.role === 'manager'
  },

  accessibleDepartments(state) {
    return state.user?.accessibleDepartments || []
  }
}

const mutations = {
  setAccessToken(state, accessToken) {
    Vue.prototype.$axios.defaults.headers.Authorization = accessToken !== null ? `jwt ${accessToken}` : null
    state.accessToken = accessToken
  },
  setRefreshToken(state, refreshToken) {
    state.refreshToken = refreshToken
  },
  setUser(state, user) {
    state.user = user
  },
  setBeforePath(state, path) {
    state.beforePath = path
  },
  setApiDomain(state, domain){
    state.apiDomain = domain
    Vue.prototype.$axios.defaults.baseURL = buildApiUrl(domain)
  }
}

const actions = {
  /**
   * 今持っている token が有効期限切れかどうかを判定する action
   * tokenが存在しないor有効期限が切れている時に true を返す
   */
  tokenIsExpired({ getters }) {
    const decodedToken = getters.decodedToken
    if (decodedToken === null) return true
    const current = Date.now() / 1000
    const expiration = decodedToken['exp']
    return current > expiration
  },

  async logout({ commit }) {
    commit('setAccessToken', null)
    commit('setRefreshToken', null)
    commit('setUser', null)
    commit('setApiDomain', null)
    return true
  },
  async updateUser({ commit }) {
    const me = await Vue.prototype.$axios.get('/accounts/me/').catch(e => {
      console.error(e)
      return null
    })
    if (!me){
      return false
    }
    commit('setUser', me.data)
    return true
  }

  /**
   * state に保存されている token が有効かどうかを **厳密に** 確認し
   * token を更新する action
   *
   * 有効な token を state に保存できたとき true を返す
   *
   * @param {*} { state, commit, getters }
   * @returns {boolean}
   */
  // async update({ state, commit, getters, dispatch }) {
  //   // そもそも token が存在しない場合
  //   console.info('exist token', getters.existToken)
  //   if (!getters.existToken) {
  //     return false
  //   }
  //   const expired = await dispatch('tokenIsExpired')
  //   // 有効期限切れの場合
  //   if (expired) {
  //     console.info('token is exist but expired')
  //     return false
  //   }
  //   const result = await this.$axios
  //     .post('/auth/token/refresh/', { refresh: state.refreshToken })
  //     .then(res => {
  //       console.info('success!!')
  //       commit('setAccessToken', res.data.accessToken)
  //       return true
  //     })
  //     .catch(e => {
  //       console.error(e.response)
  //       console.error('cant refresh... login again')
  //       commit('setAccessToken', null)
  //       return false
  //     })
  //   return result
  // },
  // async login({ commit }, payload) {
  //   const response = await this.$axios
  //     .$post('auth/login/', payload)
  //     .then(res => {
  //       return res.data
  //     })
  //     .catch(e => {
  //       console.error(e)
  //     })

  //   if (response) {
  //     commit('setToken', response.token)
  //     return 'success'
  //   }
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}